// src/components/common/VisualBadge.js
import React from 'react';
import PropTypes from 'prop-types';
import { FiZap, FiUploadCloud, FiImage } from 'react-icons/fi';

/**
 * Renders a small badge indicating the source of the AI visual.
 * @param {object} metadata - The visual.metadata object from Firestore.
 * @param {string} className - Optional extra classes for positioning.
 */
const VisualBadge = ({ metadata, className = '' }) => {
    if (!metadata || !metadata.model) return null;

    const isCloud = metadata.model.startsWith('cloud-');
    const isLocal = metadata.model.startsWith('local-');

    if (isCloud) {
        return (
            <div className={`inline-flex items-center px-2 py-0.5 rounded-md text-[10px] font-bold uppercase tracking-wider shadow-sm bg-slate-blue/20 text-slate-blue border border-slate-blue/30 ${className}`} title="Generated on Cloud GPU">
                <FiUploadCloud className="mr-1 h-3 w-3" /> Cloud GPU
            </div>
        );
    }

    if (isLocal) {
        return (
            <div className={`inline-flex items-center px-2 py-0.5 rounded-md text-[10px] font-bold uppercase tracking-wider shadow-sm bg-pastel-green-bg/20 text-pastel-green border border-pastel-green/30 ${className}`} title="Generated on Local GPU (Free)">
                <FiZap className="mr-1 h-3 w-3" /> Local Node
            </div>
        );
    }

    // Fallback for unknown models (or older uploads)
    return (
        <div className={`inline-flex items-center px-2 py-0.5 rounded-md text-[10px] font-bold uppercase tracking-wider shadow-sm bg-white/10 text-cream/60 border border-white/10 ${className}`}>
            <FiImage className="mr-1 h-3 w-3" /> AI Generated
        </div>
    );
};

VisualBadge.propTypes = {
    metadata: PropTypes.shape({
        model: PropTypes.string,
    }),
    className: PropTypes.string,
};

export default VisualBadge;